import storage from 'local-storage-fallback';

export default storage;
